.iframe {
    width: 100%;
    height: 100%;
    border: 0;
}
